<template>
	<div id="app">
		<router-view></router-view>
		<Lines :load="anim"></Lines>
	</div>
</template>

<script>
import Lines from '@/components/Lines'
export default {
	name: 'App',
	components: {
		Lines,
	},
	computed: {
		anim() {
			return this.$store.state.anim
		},
		ready() {
			return this.$store.state.ready
		}
	},
	mounted() {
		setTimeout(() => {
			this.$store.dispatch('ready');
		},2000)
	}
}
</script>

<style lang="sass">
	@font-face
		font-family: 'Favorit'
		src: url('./assets/fonts/subset-FavoritC.woff2') format('woff2'), url('./assets/fonts/subset-FavoritC.woff') format('woff'), url('./assets/fonts/subset-FavoritC.ttf') format('truetype')
		font-weight: normal
		font-style: normal
		font-display: block

	body::after
		position: absolute
		width: 0
		height: 0
		overflow: hidden
		z-index: -1
		content: url(./assets/images/list.png) url(./assets/images/list-2.png) url(./assets/images/list-3.png) url(./assets/images/list-4.png)
</style>